{
  "admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.body": [
    {
      "type": 0,
      "value": "We've brought the most relevant requests to the top."
    }
  ],
  "admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.button-done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.heading": [
    {
      "type": 0,
      "value": "Review requests quickly"
    }
  ],
  "adminhub.user.requests.count.message.spotlight.content.body": [
    {
      "type": 0,
      "value": "See how many times a user has tried to access their requested app"
    }
  ],
  "adminhub.user.requests.count.message.spotlight.content.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "adminhub.user.requests.count.message.spotlight.content.headline": [
    {
      "type": 0,
      "value": "View access attempts"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.approve-all-cta": [
    {
      "type": 0,
      "value": "Approve all"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.footer.admin-note": [
    {
      "type": 0,
      "value": "You received this email because you're an admin for "
    },
    {
      "type": 1,
      "value": "orgName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.footer.approve-all-cta": [
    {
      "type": 0,
      "value": "Approve all"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.footer.review-all-cta": [
    {
      "type": 0,
      "value": "Review all"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.footer.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Administration."
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.header.no-dates": [
    {
      "type": 0,
      "value": "Recent pending access requests"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.header.with-dates": [
    {
      "type": 0,
      "value": "Recent pending access requests from "
    },
    {
      "type": 1,
      "value": "startDate"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "endDate"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.org-icon.alt": [
    {
      "type": 0,
      "value": "Organisation icon"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.overflow-note": [
    {
      "type": 0,
      "value": "Showing "
    },
    {
      "type": 1,
      "value": "shown"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    },
    {
      "type": 0,
      "value": " requests"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.app-requested-label": [
    {
      "type": 0,
      "value": "App requested"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.approve-cta": [
    {
      "type": 0,
      "value": "Approve"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.date-label": [
    {
      "type": 0,
      "value": "Date requested"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.days-ago": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " DAY AGO"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " DAYS AGO"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "days"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.existing-access-label": [
    {
      "type": 0,
      "value": "Existing access"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.requested-by-label": [
    {
      "type": 0,
      "value": "Requested by"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.review-cta": [
    {
      "type": 0,
      "value": "Review"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.summary-fallback": [
    {
      "type": 0,
      "value": "Hi, admin 👋 I'd like to use "
    },
    {
      "type": 1,
      "value": "requestedProduct"
    },
    {
      "type": 0,
      "value": " to collaborate with my team."
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.request-card.summary-label": [
    {
      "type": 0,
      "value": "Summary"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.review-all-cta": [
    {
      "type": 0,
      "value": "Review all"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.stats.oldest-request-label": [
    {
      "type": 0,
      "value": "oldest request"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.stats.oldest-request-value": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "days"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.stats.pending-requests-label": [
    {
      "type": 0,
      "value": "pending requests"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.stats.products-label": [
    {
      "type": 0,
      "value": "products"
    }
  ],
  "growth-groot.adminhub-request-access-weekly-digest.email.subject": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " access request is"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " access requests are"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "totalPendingCount"
    },
    {
      "type": 0,
      "value": " pending your review"
    }
  ],
  "growth-groot.pending-request-access-summary.message-template.in-app-notification.body": [
    {
      "type": 0,
      "value": "Approve or deny your users' requests for app access."
    }
  ],
  "growth-groot.pending-request-access-summary.message-template.in-app-notification.heading": [
    {
      "type": 1,
      "value": "totalRequests"
    },
    {
      "type": 0,
      "value": " access requests are waiting for review"
    }
  ],
  "user.access.settings.access.message.spotlight.content.body": [
    {
      "type": 0,
      "value": "Create a message that users in your organization will see when they want to request access to an app."
    }
  ],
  "user.access.settings.access.message.spotlight.content.got.it": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "user.access.settings.access.message.spotlight.content.headline": [
    {
      "type": 0,
      "value": "Create an access message"
    }
  ]
}